import { useCustom } from '@refinedev/core';
import { useMemo } from 'react';

import { AvailableResources } from '@/config';
import { resourceConfig } from '@/config/data-provider/resourceConfig';

import type { RatioItem, RatioOption } from './types';

interface UseGetRatiosProps {
  regionId?: string;
  cycleId?: string;
  excludeConfigured?: boolean;
}

const useGetRatios = ({
  regionId,
  cycleId,
  excludeConfigured = false
}: UseGetRatiosProps) => {
  const { data, isLoading, error } = useCustom<{ ratios: RatioItem[] }>({
    url: resourceConfig[AvailableResources.RATIOS].path,
    method: 'get',
    config: {
      query: {
        region_id: regionId,
        cycle_id: cycleId,
        exclude_configured: excludeConfigured
      }
    },
    queryOptions: {
      enabled: !!regionId
    }
  });

  const options = useMemo<RatioOption[]>(() => {
    if (!data?.data?.ratios) {
      return [];
    }

    return data.data.ratios.map(ratio => ({
      label: ratio.value,
      value: ratio.value
    }));
  }, [data]);

  return {
    options,
    isLoading,
    error
  };
};

export default useGetRatios;
